/* @ngInject */
export default function CurrencyFormatterService() {
    return {
        getCurrencySymbol: function (countryCode) {
            let currencyCode = '';
            if (countryCode) {
                switch (countryCode) {
                    case 'ALL':
                        currencyCode = 'Lek';
                        break;
                    case 'AFN':
                        currencyCode = '؋';
                        break;
                    case 'ARS':
                    case 'AUD':
                    case 'BSD':
                    case 'BBD':
                    case 'BMD':
                    case 'BND':
                    case 'CAD':
                    case 'KYD':
                    case 'CLP':
                    case 'COP':
                    case 'XCD':
                    case 'SVC':
                    case 'FJD':
                    case 'GYD':
                    case 'HKD':
                    case 'LRD':
                    case 'MXN':
                    case 'NAD':
                    case 'NZD':
                    case 'SGD':
                    case 'SBD':
                    case 'SRD':
                    case 'TVD':
                    case 'USD':
                        currencyCode = '$';
                        break;
                    case 'AWG':
                    case 'ANG':
                        currencyCode = 'ƒ';
                        break;
                    case 'AZN':
                        currencyCode = 'ман';
                        break;
                    case 'BYR':
                        currencyCode = 'p.';
                        break;
                    case 'BZD':
                        currencyCode = 'BZ$';
                        break;
                    case 'BOB':
                        currencyCode = '$b';
                        break;
                    case 'BAM':
                        currencyCode = 'KM';
                        break;
                    case 'BWP':
                        currencyCode = 'P';
                        break;
                    case 'BGN':
                    case 'UZS':
                    case 'KZT':
                    case 'KGS':
                        currencyCode = '&#x43b;';
                        break;
                    case 'BRL':
                        currencyCode = 'R$';
                        break;
                    case 'KHR':
                        currencyCode = '៛';
                        break;
                    case 'CNY':
                    case 'JPY':
                        currencyCode = '¥';
                        break;
                    case 'CRC':
                        currencyCode = '₡';
                        break;
                    case 'HRK':
                        currencyCode = 'kn';
                        break;
                    case 'CUP':
                    case 'PHP':
                        currencyCode = '₱';
                        break;
                    case 'CZK':
                        currencyCode = 'Kč';
                        break;
                    case 'DKK':
                        currencyCode = 'kr';
                        break;
                    case 'DOP':
                        currencyCode = 'RD$';
                        break;
                    case 'EGP':
                    case 'FKP':
                    case 'GIP':
                    case 'GGP':
                    case 'IMP':
                    case 'JEP':
                    case 'LBP':
                    case 'SHP':
                    case 'SYP':
                    case 'GBP':
                        currencyCode = '£';
                        break;
                    case 'EUR':
                        currencyCode = '€';
                        break;
                    case 'GHS':
                        currencyCode = '¢';
                        break;
                    case 'GTQ':
                        currencyCode = 'Q';
                        break;
                    case 'HNL':
                        currencyCode = 'L';
                        break;
                    case 'HUF':
                        currencyCode = 'Ft';
                        break;
                    case 'ISK':
                        currencyCode = 'kr';
                        break;
                    case 'INR':
                        currencyCode = '&#x20b9;';
                        break;
                    case 'IDR':
                        currencyCode = 'Rp';
                        break;
                    case 'IRR':
                    case 'OMR':
                    case 'QAR':
                    case 'SAR':
                    case 'YER':
                        currencyCode = '&#xfdfc;';
                        break;
                    case 'ILS':
                        currencyCode = '&#x20aa;';
                        break;
                    case 'JMD':
                        currencyCode = 'J$';
                        break;
                    case 'KPW':
                    case 'KRW':
                        currencyCode = '&#x20a9;';
                        break;
                    case 'LAK':
                        currencyCode = '&#x20ad;';
                        break;
                    case 'MKD':
                        currencyCode = '&#x434;';
                        break;
                    case 'MYR':
                        currencyCode = 'RM';
                        break;
                    case 'MUR':
                    case 'NPR':
                    case 'PKR':
                        currencyCode = 'Rs';
                        break;
                    case 'MNT':
                        currencyCode = '&#x20ae;';
                        break;
                    case 'MZN':
                        currencyCode = 'MT';
                        break;
                    case 'NIO':
                        currencyCode = 'C$';
                        break;
                    case 'NGN':
                        currencyCode = '&#x20a6;';
                        break;
                    case 'NOK':
                    case 'SEK':
                        currencyCode = 'kr';
                        break;
                    case 'PAB':
                        currencyCode = 'B/.';
                        break;
                    case 'PYG':
                        currencyCode = 'Gs';
                        break;
                    case 'PEN':
                        currencyCode = 'S/.';
                        break;
                    case 'PLN':
                        currencyCode = '&#x7a;';
                        break;
                    case 'RON':
                        currencyCode = 'lei';
                        break;
                    case 'RUB':
                        currencyCode = '&#x440;';
                        break;
                    case 'RSD':
                        currencyCode = '&#x414;';
                        break;
                    case 'SOS':
                        currencyCode = 'S';
                        break;
                    case 'ZAR':
                        currencyCode = 'R';
                        break;
                    case 'CHF':
                        currencyCode = '';
                        break;
                    case 'TWD':
                        currencyCode = '&#x4e;';
                        break;
                    case 'THB':
                        currencyCode = '&#xe3f;';
                        break;
                    case 'TTD':
                        currencyCode = 'TT$';
                        break;
                    case 'TRY':
                        currencyCode = '&#x20ba;';
                        break;
                    case 'UAH':
                        currencyCode = '&#x20b4;';
                        break;
                    case 'UYU':
                        currencyCode = '$U';
                        break;
                    case 'VEF':
                        currencyCode = 'Bs';
                        break;
                    case 'VND':
                        currencyCode = '&#x20ab;';
                        break;
                    case 'ZWD':
                        currencyCode = 'Z$';
                        break;
                }
            } else {
                currencyCode = '--';
            }
            return currencyCode;
        },
    };
}
